<template>
  <FontAwesomeIcon v-if="icon" :icon="['fal', icon]" v-tooltip="label" />
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    icon() {
      if (!this.$path('deliveryLogs.length', this.value)) return
      if (this.value.deliveryLogs.find(l => l.events.find(e => e.event === 'click'))) return 'envelope-open'
      return 'envelope'
    },
    label() {
      if (!this.$path('deliveryLogs.length', this.value)) return
      if (this.value.deliveryLogs.find(l => l.events.find(e => e.event === 'click')))
        return this.$t('deliveryLogClickLabel', { resource: this.$tc('shop') })
      return this.$t('deliveryLogDeliveredLabel', { resource: this.$tc('shop') })
    },
  },
}
</script>
